module.exports = __webpack_public_path__ + "img/null_icon_data.8a2d0fae.png";